import { useMutation } from '@tanstack/react-query';
import { notification } from 'antd';

import { apiV1 } from '@/lib/axios';
import { MutationConfig, queryClient } from '@/lib/react-query';

export type CreateEventDTO = {
  companyId: string;
  title: string;
  description: string;
  local?: string;
  before_market?: 'time' | 'before_market' | 'after_market' | 'full_day';
  start_date: string;
  end_date?: string;
  impact_id: number;
  event_type_id: number;
  shareholders: string[];
  contact_ids: string[];
  is_created_by_admin?: boolean;
};

export const createEvent = async (data: CreateEventDTO): Promise<unknown> => {
  return apiV1.post(`/v1/irm/event`, {
    title: data.title,
    description: data.description,
    local: data.local,
    before_market: data.before_market,
    start_date: data.start_date,
    end_date: data.end_date,
    impact_id: data.impact_id,
    event_type_id: data.event_type_id,
    shareholders: data.shareholders,
    contact_ids: data.contact_ids,
    company_id: data.companyId,
    is_created_by_admin: data.is_created_by_admin || false,
  });
};

type UseCreateEventOptions = {
  config?: MutationConfig<typeof createEvent>;
};

export const useCreateEvent = ({ config }: UseCreateEventOptions) => {
  return useMutation({
    onError: () => {
      notification.error({
        message: `Não foi possível atualizar oevento.`,
      });
    },
    onSuccess: (_, variables) => {
      queryClient.invalidateQueries(['events', variables.companyId]);
      notification.success({
        message: `Evento criado com sucesso.`,
      });
    },
    ...config,
    mutationFn: createEvent,
  });
};
